module.exports = function dynamicContentDialog(dynamicContentService, dialogRegistry) {
    return {
        restrict: 'A',
        scope: {
            dialogName: '@olyDcDialog',
            scheduleKey: '=?'
        },
        transclude: true,
        link(scope, element) {
            const dialog = dialogRegistry.getDialog(scope.dialogName);

            // We disable the mask when dynamic content management is enabled
            // so that it doesn't cover up the dynamic content management tool
            // and make it impossible to edit dynamic content.
            const shouldMask = !dynamicContentService.isManagementEnabled();

            // We set the schedule key to null because we don't want to load
            // the dynamic content until the dialog is shown.
            const scheduleKey = scope.scheduleKey || scope.dialogName;
            scope.scheduleKey = null;

            element.on('click.dcDialog', function () {
                scope.$apply(function () {
                    scope.scheduleKey = scheduleKey;
                });
            });

            scope.showDialog = function () {
                dialog.show(shouldMask)
                    .finally(function () {
                        // When the dialog is closed, we set the schedule key to null
                        // in order to destroy the dynamic content. This is important
                        // in case something like a YouTube video is playing in the dialog.
                        scope.scheduleKey = null;
                    });
            };

            scope.$on('$destroy', function () {
                element.off('click.dcDialog');
            });
        },
        template: require('./dynamic-content-dialog-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/dynamic-content-dialog-directive.js
 **/